// Shared normalizer for the Bookings list and Calendar status filters.
//
// A waiver on an unbooked slot never changes the slot's status; the console
// offers a "Has waivers" toggle instead of the old checked status. Saved views
// and URLs written before that change may still carry status=checked, so it is
// read as the toggle and dropped from the status list (OTC-3117).
export function normalizeStatusFilter(filterValues) {
  const values = filterValues || {}
  const rawStatuses = Array.isArray(values.status) ? values.status : []
  const hasWaivers = values.has_waivers === true || rawStatuses.includes('checked')
  const status = rawStatuses.filter(s => s !== 'checked').join(',')
  return { status, hasWaivers }
}
